import { message } from "antd";
import ReactGA from "react-ga4";
import posthog, { isPostHogReady } from "../analytics/posthogClient";

export const eventTracker = (category, action, label) => {
  if (!category || !action) {
    message.error("Category and action are required for tracking events");
    return;
  }
  ReactGA.event({ category, action, label });

  if (isPostHogReady()) {
    posthog.capture(label ? `${category}: ${label}` : `${category}: ${action}`, {
      category,
      action,
      label,
    });
  }
};
